"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_svg_1 = __importDefault(require("@doordash/component-svg"));
var design_language_1 = require("@doordash/design-language");
var lodash_get_1 = __importDefault(require("lodash.get"));
var React = __importStar(require("react"));
/* tslint:disable:max-line-length */
var SecurityUpdateIcon = function (_a) {
    var size = _a.size, color = _a.color;
    var theme = React.useContext(design_language_1.ThemingContext);
    var strokeColor = lodash_get_1["default"](theme, 'Colors.TextAction', design_language_1.Colors.SystemRed60);
    return (React.createElement(component_svg_1["default"], { height: size, width: size, fill: color, viewBox: "0 0 50 49" },
        React.createElement("path", { fill: "none", d: "M.98.98h47.04v47.04H.98z" }),
        React.createElement("path", { fill: "none", d: "M.98.98h47.04v47.04H.98z" }),
        React.createElement("path", { fill: "none", d: "M.98 25.523h40.904v22.496H.98z" }),
        React.createElement("path", { stroke: strokeColor, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10", strokeWidth: "2", d: "M12.229 25.523C6.093 25.523.98 30.636.98 36.77c0 6.136 5.113 11.249 11.249 11.249 5.113 0 9.408-3.477 10.84-8.18h2.454l2.045 2.044 2.045-2.045h2.045l2.045 2.045 2.046-2.045h3.067l3.068-3.068-3.068-3.068H23.069c-1.431-4.704-5.726-8.18-10.84-8.18z" }),
        React.createElement("path", { stroke: strokeColor, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10", strokeWidth: "2", d: "M8.138 39.84a3.068 3.068 0 1 0 0-6.136 3.068 3.068 0 0 0 0 6.135z" }),
        React.createElement("path", { fill: "none", d: "M21.432.98H48.02v34.768H21.432z" }),
        React.createElement("path", { stroke: strokeColor, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10", strokeWidth: "2", d: "M34.726 22.455a1.023 1.023 0 1 0 0-2.046 1.023 1.023 0 0 0 0 2.046zM34.726 22.455v4.09" }),
        React.createElement("path", { stroke: strokeColor, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10", strokeWidth: "2", d: "M45.975 35.749h2.045V15.296H21.432v8.181" }),
        React.createElement("path", { stroke: strokeColor, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10", strokeWidth: "2", d: "M25.523 15.296v-5.112A9.165 9.165 0 0 1 34.726.98a9.165 9.165 0 0 1 9.204 9.204v5.113" })));
};
/* tslint:enable:max-line-length */
exports["default"] = SecurityUpdateIcon;
